
import { Menu, X } from "lucide-react";
import NavLinks from "./NavLinks";
import { useAuth } from "@/context/AuthContext";
import { Link } from "react-router-dom";
import { Button } from "@/components/ui/button";

interface MobileMenuProps {
  isOpen: boolean;
  toggleMenu: () => void;
}

const MobileMenu = ({ isOpen, toggleMenu }: MobileMenuProps) => {
  const { user } = useAuth();

  return (
    <>
      <button
        type="button"
        className="inline-flex items-center p-2 w-10 h-10 justify-center text-sm text-gray-500 rounded-lg md:hidden hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-gray-200 dark:text-gray-400 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
        aria-controls="navbar-sticky"
        aria-expanded={isOpen}
        onClick={toggleMenu}
      >
        <span className="sr-only">Open main menu</span>
        {isOpen ? (
          <X className="w-5 h-5" />
        ) : (
          <Menu className="w-5 h-5" />
        )}
      </button>
      
      <div
        className={`items-center justify-between w-full md:hidden ${
          isOpen ? "block" : "hidden"
        }`}
        id="navbar-sticky"
      >
        <ul className="flex flex-col p-4 md:p-0 mt-4 font-medium border border-gray-100 rounded-lg bg-gray-50 md:space-x-8 rtl:space-x-reverse md:flex-row md:mt-0 md:border-0 md:bg-white dark:bg-gray-800 md:dark:bg-gray-900 dark:border-gray-700">
          <NavLinks isMobile={true} onMobileItemClick={toggleMenu} />
          
          <li className="mt-2">
            <Link 
              to="/crime-map" 
              className="block w-full"
              onClick={toggleMenu}
            >
              <Button variant="outline" className="w-full">
                Crime Map
              </Button>
            </Link>
          </li>
          
          <li className="mt-2">
            <Link 
              to="/report-crime" 
              className="block w-full"
              onClick={toggleMenu}
            >
              <Button className="w-full bg-okkio-orange hover:bg-okkio-orange/90 text-white">
                Report Crime
              </Button>
            </Link>
          </li>
          
          {user && (
            <li className="mt-2">
              <Link 
                to="/upgrade" 
                className="block w-full"
                onClick={toggleMenu}
              >
                <Button className="w-full bg-okkio-orange hover:bg-okkio-orange/90 text-white">
                  Upgrade
                </Button>
              </Link>
            </li>
          )}
        </ul>
      </div>
    </>
  );
};

export default MobileMenu;
